module.exports = __webpack_public_path__ + "static/media/error_illustration_fisdom.c2cf947c.svg";